import { render, staticRenderFns } from "./SessionHeader.vue?vue&type=template&id=2fe5b278&scoped=true&"
import script from "./SessionHeader.vue?vue&type=script&lang=js&"
export * from "./SessionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SessionHeader.vue?vue&type=style&index=0&id=2fe5b278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5b278",
  null
  
)

export default component.exports